const DEFAULT_ERROR_MESSAGE = '请求失败，请稍后重试'

export const getRequestErrorMessage = (error, fallbackMessage = DEFAULT_ERROR_MESSAGE) => {
  if (typeof error === 'string' && error.trim()) {
    return error
  }
  return error?.msg || error?.message || fallbackMessage
}

export const handleRequestError = (error, fallbackMessage = DEFAULT_ERROR_MESSAGE) => {
  const message = getRequestErrorMessage(error, fallbackMessage)
  uni.showToast({
    title: message,
    icon: 'none'
  })
  console.error('[API_ERROR]', error)
}
